import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingScreen from "src/components/LoadingScreen";
import useAuth from "src/hooks/useAuth";
import { PATH_DASHBOARD } from "src/routes/paths";
import { hasRouteAccess } from "src/routes/permissions";
import { Storage } from "src/utils/storage";

type PermissionGuardProps = {
    children: ReactNode;
};

export default function PermissionGuard({ children }: PermissionGuardProps) {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { userState } = useAuth();

    const permissions = userState?.roles || Storage.getItem("userRoles");
    const shouldWaitForPermissions = !!userState?.company && permissions === null;
    const hasCurrentRouteAccess = permissions ? hasRouteAccess(pathname, permissions) : true;

    useEffect(() => {
        if (!shouldWaitForPermissions && permissions && !hasCurrentRouteAccess) {
            navigate(PATH_DASHBOARD, { replace: true });
        }
    }, [hasCurrentRouteAccess, navigate, permissions, shouldWaitForPermissions]);

    if (shouldWaitForPermissions) {
        return <LoadingScreen />;
    }

    if (permissions && !hasCurrentRouteAccess) {
        return <LoadingScreen />;
    }

    return <>{children}</>;
}
